import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { tap } from 'rxjs/internal/operators/tap';
import { Address } from '../models/Address';
import { AdverseActionLetter } from '../models/AdverseActionLetter';
import { ScreeningService } from '../services/screening.service';

@Component({
  selector: 'app-aal',
  templateUrl: './aal.component.html',
  styleUrls: ['./aal.component.less']
})
export class AalComponent implements OnInit {
  loaded: boolean = false;
  token: string;
  aal: AdverseActionLetter;
  today: Date = new Date();

  public get locationPhyiscalAddress() : Address {
    
    return this.aal.location.addresses.find(add => { return add.physical })
  }

  constructor(private activatedRoute: ActivatedRoute, private screening: ScreeningService) { }

  ngOnInit(): void {
    this.activatedRoute.paramMap.pipe(
      tap((_ : ParamMap) => {
        this.token = _.get('token');
        this.screening.FetchAALDocumentData(this.token).pipe(
          tap((_ : AdverseActionLetter) => {
            this.aal = Object.assign(new AdverseActionLetter(),_);
            console.log(this.aal);
            this.loaded = true;
          })
        ).subscribe();
      })
    ).subscribe();
  }

}
